import {
  createStyles,
  ListItemText,
  Theme,
  withStyles,
} from '@material-ui/core'

export const TargetPriceTooltipListItemText = withStyles((theme: Theme) =>
  createStyles({
    secondary: {
      ...theme.typography.body2,
    },
    primary: {
      ...theme.typography.caption,
    },
  })
)(ListItemText)
